import { z } from 'zod'

export const CorrelationIdSchema = z.string().guid().nullable()

// Used to document and limit headers sent with requests
export const HEADER_KEYS = {
  xffHeader: 'x-forwarded-for',
  partnerCode: 'x-partner',
  platformType: 'x-platform-type',
  correlationId: 'x-correlation-id',
  authorization: 'authorization',
  referer: 'referer',
  host: 'host',
  cookie: 'cookie',
  setCookie: 'Set-Cookie',
  forwardedHost: 'x-forwarded-host',
  apiCallbackUrl: 'x-api-callback-url',
  countryCode: 'x-country-code',
  currencyCode: 'x-currency-code',
  userAgent: 'user-agent',
  searchEngine: 'x-search-engine',
  languageCode: 'x-language-code',
  phubId: 'x-phubid',
} as const

export type HeaderKey = keyof typeof HEADER_KEYS
export type HeaderName = (typeof HEADER_KEYS)[HeaderKey]

export const RequestHeadersSchema = z.object({
  [HEADER_KEYS.authorization]: z
    .string()
    .regex(/^Bearer\W[A-Za-z0-9_-]{2,}(?:\.[A-Za-z0-9_-]{2,}){2}$/)
    .optional()
    .nullable(),
  [HEADER_KEYS.referer]: z.string().optional().nullable(),
  [HEADER_KEYS.correlationId]: z
    .string()
    .regex(/[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/)
    .optional()
    .nullable(),
  [HEADER_KEYS.partnerCode]: z.enum(['BA', 'EI', 'IB']),
  [HEADER_KEYS.platformType]: z.string().optional().default('whitelabel'),
  [HEADER_KEYS.host]: z.string().optional().nullable(),
  [HEADER_KEYS.cookie]: z.string().optional().nullable(),
  [HEADER_KEYS.setCookie]: z.string().optional().nullable(),
  [HEADER_KEYS.apiCallbackUrl]: z.string().optional().nullable(),
  [HEADER_KEYS.forwardedHost]: z.string().optional().nullable(),
  // TODO: validate using schemas from libs once all merged
  [HEADER_KEYS.currencyCode]: z.string().optional().nullable(),
  [HEADER_KEYS.countryCode]: z.string().optional().nullable(),
  [HEADER_KEYS.userAgent]: z.string().optional().nullable(),
  [HEADER_KEYS.searchEngine]: z.string().optional().nullable(),
  [HEADER_KEYS.languageCode]: z.string().optional().nullable(),
  [HEADER_KEYS.phubId]: z.string().optional().nullable(),
})
